import React, { useEffect, useRef } from 'react';
import Modal from '@/components/modal';
import './index.less';
import { Button } from 'antd';

export default (props) => {
  const { hints = [], iSeeIt = () => {} } = props;
  const guideRef = useRef([]);

  useEffect(() => {
    if (hints.length > 0) {
      const sidebarScrollEle = document.getElementById('side-bar-scroll');
      const screenHeight = document.body.clientHeight - 150;

      hints.forEach((item, index) => {
        if (guideRef.current[index]) {
          const ele = item.element;
          let top = getOffsetTop(ele) - sidebarScrollEle.scrollTop;
          if (top - screenHeight > 0) {
            sidebarScrollEle.scrollTop = getOffsetTop(ele);
            top = getOffsetTop(ele) - sidebarScrollEle.scrollTop;
          }
          const left = ele.offsetLeft;
          if (item.direction == 'bottom') {
            const height = ele.clientHeight;
            guideRef.current[index].style.left = left + 'px';
            guideRef.current[index].style.top = top + height + 'px';
          } else {
            const width = ele.clientWidth;
            guideRef.current[index].style.left = left + width + 10 + 'px';
            guideRef.current[index].style.top = top + 'px';
          }
        }
      });
    }
  }, [hints]);

  function getOffsetTop(element) {
    let actualTop = element.offsetTop;

    let current = element.offsetParent;

    while (current !== null) {
      actualTop += current.offsetTop;

      current = current.offsetParent;
    }

    return actualTop;
  }
  if (hints.length <= 0) return null;

  return (
    <>
      {hints.map((item, index) => (
        <>
          {index == 0 && (
            <Modal key={index}>
              <div className="auto-guide" ref={(el) => (guideRef.current[index] = el)}>
                <div className="auto-guide__header">{item.title}</div>
                <div className="auto-guide__text">{item.intro}</div>
                <div className="auto-guide__btn">
                  <Button className="auto-guide__btn-item" onClick={() => iSeeIt(item.menuId)}>
                    {item.button}
                  </Button>
                </div>
                <div className={`auto-guide__arrow ${item.direction}`}></div>
              </div>
              {/* <div className="auto-guide-overlay"></div> */}
            </Modal>
          )}
        </>
      ))}
    </>
  );
};
